export const digitsOnly = (evt) => {
  evt.preventDefault();
  const clipboardData = evt.clipboardData.getData('text');
  return clipboardData.replace(/[^\d]/g, '');
};

const hasBeenUpdated = (currentList = [], previousList = [], attributeToCheck = null) => {
  const current = new Set(
    currentList?.filter((item) => item !== null)?.map((item) => item?.[attributeToCheck] ?? item)
  );
  const previous = new Set(
    previousList?.filter((item) => item !== null)?.map((item) => item?.[attributeToCheck] ?? item)
  );

  if (current.size !== previous.size) {
    return true;
  }

  for (const item of current) {
    if (!previous.has(item)) {
      return true;
    }
  }

  return false;
};

export const yearIsUpdated = (currentList, previousList) =>
  hasBeenUpdated(currentList, previousList);

export const makesListIsUpdated = (currentList, previousList) =>
  hasBeenUpdated(currentList, previousList, 'makeId');

export const filterIsUpdated = (currentList, previousList) =>
  hasBeenUpdated(currentList?.['bodyStyles'], previousList?.['bodyStyles']) ||
  hasBeenUpdated(currentList?.['sizes'], previousList?.['sizes']) ||
  hasBeenUpdated(currentList?.['fuelTypes'], previousList?.['fuelTypes']);

export const getValueOrDefault = (originalValue, defaultValue) => {
  return originalValue?.length !== 0 ? originalValue : defaultValue;
};

export const groupModelsByMakeOrder = (makesArray = [], modelsArray = []) => {
  return makesArray.map((make) => {
    return modelsArray.filter((model) => model?.makeId === make?.makeId);
  });
};
